import React, { useRef, useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import {
  Grid
} from '@mui/material'
import { Save } from '@mui/icons-material'

import DialogFullScreen from './DialogFullScreen'
import CustomTextField from '../atoms/CustomTextField'
import RichTextEditor from '../../lexical/RichTextEditor'

const EmailEditDialog = (props) => {
  const {
    open,
    onSave,
    handleClose,
    firmData,
    saving = false
  } = props

  const { t } = useTranslation()

  const exportHtmlRef = useRef()

  const [subject, setSubject] = useState('')
  const [subjectErr, setSubjectErr] = useState(false)

  const handleSubmit = () => {
    if (!subject) {
      setSubjectErr(true)
    } else {
      const exportedHtml = exportHtmlRef.current.exportHtml()

      onSave({
        firmId: firmData?.id,
        subject,
        html: exportedHtml
      })
    }
  }

  useEffect(() => {
    if (open && firmData) {
      setSubject(firmData?.emailSubject || '')
      setSubjectErr(false)
    }
  }, [open, firmData])

  return (
    <DialogFullScreen
      open={open}
      handleClose={handleClose}
      onSubmit={handleSubmit}
      btnText={t('mailTemplate.wizard.rte.saveBtn')}
      btnIcon={<Save/>}
      loading={saving}
      title={`${t('mailTemplate.wizard.firmList.editEmail')} - ${firmData?.name || ''}`}
      submitDisabled={saving || subjectErr}
    >
      <Grid container spacing={2} className='p-2'>
        <Grid item xs={12}>
          <CustomTextField
            fullWidth
            placeholder={t('mailTemplate.mailbox.email.subject')}
            value={subject}
            onChange={(e) => {
              setSubject(e.target.value)
              if (e.target.value && subjectErr) {
                setSubjectErr(false)
              }
            }}
            error={subjectErr}
            helperText={subjectErr ? t('mailTemplate.mailbox.email.subjectErr') : null}
          />
        </Grid>
      </Grid>
      <RichTextEditor templateHtml={firmData?.emailContent || ''} ref={exportHtmlRef}/>
    </DialogFullScreen>
  )
}

export default EmailEditDialog
